import { Component, OnInit, Input, ContentChildren, TemplateRef, Output } from "@angular/core";
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

export class CurrentItem {
  id: string;
  text: string;
  url?: string;
  items?: CurrentItem[];
  };
@Component({
  selector: "crem-nav",
  templateUrl: "./left-nav.component.html",
  styleUrls: ["./left-nav.component.scss"]
})
export class LeftNavComponent implements OnInit {
  url;
  selectItem$ = new Observable();
  currentItem:any;
  @Input() currentItems: CurrentItem[] ;

  @ContentChildren('items', {descendants: true}) items: TemplateRef<any>;

 constructor(private router: Router){

 }
  ngOnInit() {
    this.currentItem= this.currentItems[0];
    this.url = this.selectItem$.subscribe((onclick)=>{return this.currentItem.url});
  }
  selectItem(e){
    this.currentItem= e;
    this.url = this.selectItem$.subscribe((onclick)=>{return this.currentItem.url});
    this.router.navigateByUrl(this.url);
  }
}
